<template>
  <card>
    <form class="w-100" @submit="submit">
      <div v-if="!err">

      <h1 class="h4 mt-0 d-flex justify-content-between">
        <span>Genel Ayarlar</span>
        <button type="submit" class="btn btn-info btn-sm btn-fill">Kaydet</button>
      </h1>
      <div class="row">
        <div class="col-4" v-for="item in  settings" :key="item.id">
          <label  :class="item.meta.labelClass" :id="item.meta.id" :for="item.name"><span class="title">{{item.meta.title}}</span> <span v-if="item.meta.subTitle">({{item.meta.subTitle}})</span></label>
          <input   :type="item.meta.type" :disabled="item.meta.disabled" :class="item.meta.class" v-model="item.data" :id="item.name" class="form-control">
          <iframe v-if="item.meta.ismap" width="100%" height="315" :src="item.data" frameborder="0"></iframe>
        </div>
      </div>
            </div>
<div v-if="err">
{{err}}
</div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        settings:null,
        position: {
          lat:39.902372948487,
          lng:32.859761160718
        },
        err:null
      }
    },
    components: {
      Card
    },
    methods: {
      getSettings: function(){
        this.toggleLoader()
        this.$http.get('/api/settings/get-settings/').then(response => {
          this.settings = response.body
          for (var i = 0; i < this.settings.length; i++) {
            this.settings[i].meta = JSON.parse(this.settings[i].meta)
            if(this.settings[i].name === "latitude"){
              this.position.lat = parseFloat(this.settings[i].data)
            }
            if(this.settings[i].name === "longitude"){
              this.position.lng = parseFloat(this.settings[i].data)
            }
          }
          
          this.toggleLoader()
        }, er => {
                      if(!er.body.Error){
             this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            }else{
              this.err = er.body.Error;
            this.notifier(
              'top',
              'right',
              'danger',
              er.body.Error
              )
            }
            this.toggleLoader();
        })
      },
      submit: function(){
        event.preventDefault()
        this.$http.post('/api/settings/update-bulk-general/', this.settings).then(
          response => {
            this.notifier('top', 'right', 'success', 'Sıralama güncellendi')
          },
          e => {
                                 if(!e.body.Error){
            this.notifier(
              "top",
              "right",
              "danger",
              "Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz."
            );
            }else{
            this.notifier(
              "top",
              "right",
              "danger",
              e.body.Error
            );
            }
          })
      },
      changePosition: function(e){
        this.position.lat = e.lat()
        this.position.lng = e.lng()
        for (var i = 0; i < this.settings.length; i++) {
          if(this.settings[i].name === "latitude"){
            this.settings[i].data = e.lat()
          }
          if(this.settings[i].name === "longitude"){
            this.settings[i].data = e.lng()
          }
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getSettings()
      })
    }
  }
</script>
<style>
.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  background-color: #007bff !important;
}
.nav-pills:focus{
  outline: none;
}
.nav-pills a{
  color:#000;
}

.nav .nav-item .nav-link:hover, .nav .nav-item .nav-link:focus{
  color:#fff;
}
.nav-item{
  margin-bottom: 5px;
}
.menu-item:hover{
  cursor: move;
}
.panel-map {
    width: 100%;
    height: 2.7rem!important;
    margin-bottom: 1rem;
}
label .title{
  text-transform: capitalize;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/SettingModules/Index.vue